import { MissingStatement } from '@/features/user/your-practice/documents/lib/userDocuments.slice'
import { isoToUTCDateTime, DATE_FORMATS_LUXON } from '@/utils/dateHelpers'
import { TypographyStyles } from '@/styles'
import { Accordion, List, Text } from '@/ui'

interface MissingStatementsProps {
  neededStatements?: MissingStatement[]
  title: string
}

export const MissingStatementsAccordion = ({
  neededStatements,
  title,
}: MissingStatementsProps) => {
  if (!neededStatements || neededStatements.length === 0) {
    return null
  }

  return (
    <Accordion variant="text" type="single" collapsible>
      <Accordion.Item value="item-1">
        <Accordion.Trigger>{title}</Accordion.Trigger>

        <Accordion.Content>
          {neededStatements.map(
            ({ financial_institution_name, name, mask, statements }) => {
              const accountText = `${financial_institution_name} ${name}: ${mask}`

              return (
                <div key={accountText}>
                  <Text variant={TypographyStyles.BODY_SM} className="mt-2">
                    {accountText}
                  </Text>

                  <List className="list-disc ml-2 my-2">
                    {statements.map((statement) => (
                      <List.Item key={`${accountText} ${statement}`}>
                        <Text className="text-orange-100 mb-1">
                          {isoToUTCDateTime(statement).toFormat(
                            DATE_FORMATS_LUXON.MONTH_YEAR_LONG
                          )}
                        </Text>
                      </List.Item>
                    ))}
                  </List>
                </div>
              )
            }
          )}
        </Accordion.Content>
      </Accordion.Item>
    </Accordion>
  )
}
